<div class="qr-wrapper">
  <!-- Card nhập thông tin -->
  <div class="form-card">
    <div class="form-group">
      <label>Số tài khoản</label>
     <input
      type="text"
      [(ngModel)]="accountNumber"
      placeholder="Nhập số tài khoản"
      (keypress)="onlyNumberInput($event)"
    />
    </div>

    <div class="form-group">
      <label>Số điện thoại</label>
      <input
        type="text"
        [(ngModel)]="phoneNumber"
        placeholder="Nhập số điện thoại khách hàng"
        maxlength="11"
        (keypress)="onlyNumberInput($event)"  
      />
    </div>

    <div class="form-group">
      <label>Mã thiết bị</label>
      <input
        type="text"
        [(ngModel)]="deviceCode"
        placeholder="Nhập mã thiết bị"
        (input)="filterAlphaNumeric($event)"
      />
    </div>

    <div class="qr-container">
      <qr-code
        [value]="'DEMO-QR'"
        [size]="140"
        [margin]="0"
        [errorCorrectionLevel]="'M'"
      ></qr-code>
    </div>

    <div class="option-row">
      <div class="option-title">Nền QR</div>
      <div class="radio-group">
        <label
          ><input
            type="radio"
            name="background"
            [(ngModel)]="backgroundTemp"
            value="with-bg"
          />
          Có nền</label
        >
        <label
          ><input
            type="radio"
            name="background"
            [(ngModel)]="backgroundTemp"
            value="no-bg"
          />
          Không nền</label
        >
      </div>
    </div>

    <div class="option-row">
      <div class="option-title">Chọn loại QR</div>
      <div class="radio-group">
        <label
          ><input
            type="radio"
            name="qrType"
            [(ngModel)]="qrTypeTemp"
            value="with-name"
          />
          Có tên</label
        >
        <label
          ><input
            type="radio"
            name="qrType"
            [(ngModel)]="qrTypeTemp"
            value="no-name"
          />
          Không tên</label
        >
      </div>
    </div>

    <div class="option-row">
      <div class="option-title">Số lượng QR</div>
      <div class="radio-group">
        <label
          ><input
            type="radio"
            name="quantity"
            [(ngModel)]="quantityTemp"
            [value]="2"
          />
          2 QR</label
        >
        <label
          ><input
            type="radio"
            name="quantity"
            [(ngModel)]="quantityTemp"
            [value]="1"
          />
          1 QR</label
        >
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <button class="gen-btn btn-success" (click)="exportPDF()">
        Xuất PDF
      </button>
      <button class="gen-btn ml-4 btn btn-primary" (click)="generateQR()">
        Gen mã QR
      </button>
    </div>
  </div>

  <!-- Danh sách QR -->
  <div class="poster-container" id="pdf-content">
    <div *ngFor="let qr of qrList" class="qr-card">
      <div
        class="qr-main"
        [ngClass]="qr.background === 'no-bg' ? 'no-bg' : 'with-bg'"
      >
        <ng-container *ngIf="qr.background === 'with-bg'">
          <img src="assets/images/logo_hd.png" class="qr-logo" />
          <div class="qr-subtitle">Ting ting vào ví - Buôn bán như ý</div>
          <div class="qr-action mt-4">QUÉT MÃ ĐỂ THANH TOÁN</div>
        </ng-container>

        <div class="qr-box">
          <div
            [ngClass]="
              qr.qrType === 'with-name'
                ? 'qr-frame with-name'
                : 'qr-frame no-name'
            "
          >
            <qr-code [value]="qr.value" [size]="200" [margin]="1"></qr-code>

            <div class="qr-info-inline" *ngIf="qr.qrType === 'with-name'">
              <div class="qr-info-row">
                <div class="qr-label">HỌ TÊN:</div>
                <div class="qr-value">{{ qr.fullName }}</div>
              </div>
              <div class="qr-info-row">
                <div class="qr-label">STK:</div>
                <div class="qr-value">{{ qr.account }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="hotline" *ngIf="qr.background === 'with-bg'">
          HOTLINE: 1900 99.88.93
        </div>
      </div>

      <div *ngIf="qr.background === 'with-bg'" class="qr-footer">
        <img src="assets/images/Normal.png" class="qr-footer-logo" />
        <span class="qr-footer-separator"></span>
        <div class="qr-footer-text">
          <p>Tặng loa miễn phí</p>
          <p>Bảo hành 1 đổi 1 trọn đời</p>
        </div>
      </div>

      <div *ngIf="qr.background === 'with-bg'" class="qr-footer-divider"></div>
    </div>
  </div>
</div>
